import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../app/store';
import { getUserProfile } from '../../features/auth/authSlice';
import { CircularProgress, Box } from '@mui/material';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const { token, user, isLoading } = useSelector((state: RootState) => state.auth);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const savedToken = localStorage.getItem('token');
      
      if (savedToken && !user) {
        // If we have a token but no user data, try to get the user profile
        try {
          await dispatch(getUserProfile()).unwrap();
        } catch (error) {
          console.error('Failed to get user profile:', error);
        }
      }
      
      // Finish checking regardless of the result
      setIsChecking(false);
    };
    
    checkAuth();
  }, [dispatch, user]);

  // Show loading state while checking authentication
  if (isChecking || isLoading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <CircularProgress />
      </Box>
    );
  }

  // Check if token exists in both Redux and localStorage for maximum reliability
  const savedToken = localStorage.getItem('token');
  if (!token && !savedToken) {
    // Redirect to login page but save the attempted URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute; 